import { render, staticRenderFns } from "./FormMainDetails.vue?vue&type=template&id=a26db612"
import script from "./FormMainDetails.vue?vue&type=script&lang=js"
export * from "./FormMainDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports